// Custom Product Logic for Shopify
(function() {
    'use strict';
    // Track page views (enhanced)
    document.addEventListener('DOMContentLoaded', function() {
        const paymentTermsElement = document.querySelector('shopify-payment-terms');
        if (paymentTermsElement) {
            paymentTermsElement.remove();
        }

        const productNames = [
            'cedar-cold-plunge',
            'cedar-soaking-tub',
            'cedar-hot-tub',
            'barrel-cedar-sauna',
            'cedar-cistern'
        ];

        const isProductUrl = productNames.filter((productName) => window.location.pathname.indexOf(productName) >= 0).length >= 0;

        if (!isProductUrl) {
            return;
        }        

        // remove the shipping is a flat-rate ... text
        document.querySelectorAll('pickup-availability').forEach(el => el.remove());

        // we need this observer to wait for mw-apo-add-to-cart-cloned to appear since it doesn't render as part of liquid
        // but rather some background mw-apo functions that we do not have visibility on
        const observer = new MutationObserver(() => {
            const container = document.querySelector('.product-form__buttons');
            const button = document.querySelector('.mw-apo-add-to-cart-cloned');

            if (container && button && !container.querySelector('.mw-added-or-duplicate')) {
                const createQuoteButton = () => {
                    const clone = button.cloneNode(true);
                    clone.classList.add('mw-added-or-duplicate');
                    clone.removeAttribute('id');

                    // Change text
                    const span = clone.querySelector('span');
                    if (span) span.textContent = 'Get a quote';
                    else clone.textContent = 'Get a quote';

                    // Click handler
                    clone.addEventListener('click', async (e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        const title = document.querySelector('.product__title > h1')?.textContent.trim() || '';
                        const optionsSelected = Object.keys(apoCustomSelectionsForestCoop || {})
                            .filter(key => {
                                const selection = apoCustomSelectionsForestCoop[key];
                                return selection?.label &&
                                    !selection.label.includes('Please Select') &&
!selection.label.includes('None') &&
selection.label.trim() !== 'Select';
                            })
                            .map(key => apoCustomSelectionsForestCoop[key].label);

             const notes = `${title}${optionsSelected.length > 0 ? ` with ${optionsSelected.join(', ')}` : ''}`;
            window.location.href = '/pages/request-a-quote?product=' + encodeURIComponent(title) + '&notes=' + encodeURIComponent(notes);
                    });

                    return clone;
                };

                // 1️⃣ Insert button into product-form__buttons
                const orSep = document.createElement('div');
                orSep.textContent = 'OR';
                orSep.className = 'mw-or-separator';
                orSep.setAttribute('aria-hidden', 'true');

                container.insertBefore(createQuoteButton(), container.firstChild);
                container.insertBefore(orSep, button);

                // 2️⃣ Also insert a copy right after the product title
                const titleDiv = document.querySelector('.product__title');
                if (titleDiv && !document.querySelector('.mw-quote-under-title')) {
                    const quoteUnderTitle = createQuoteButton();
                    quoteUnderTitle.classList.add('mw-quote-under-title');
                    titleDiv.insertAdjacentElement('afterend', quoteUnderTitle);
                }

                // Simple style for "OR" separator
                const style = document.createElement('style');
                style.textContent = `
                    .mw-or-separator {
                        text-align: center;
                        font-weight: 600;
                        margin: 0.5em 0;
                        user-select: none;
                    }
                    .mw-quote-under-title {
                        display: inline-block;
                        margin-top: 1rem;
                    }
                    .quote-button-loading {
                        display: inline-block;
                        width: 20px;
                        height: 20px;
                        border: 3px solid #f3f3f3;
                        border-top: 3px solid #333;
                        border-radius: 50%;
                        animation: spin 1s linear infinite;
                    }
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    .quote-button-success {
                        display: inline-block;
                        color: #28a745;
                        font-size: 24px;
                        font-weight: bold;
                    }
                    .quote-error-message {
                        background: #fee;
                        border: 1px solid #fcc;
                        color: #c33;
                        padding: 12px 16px;
                        border-radius: 4px;
                        margin-bottom: 16px;
                        font-size: 14px;
                    }
                `;
                document.head.appendChild(style);

                observer.disconnect();
            }

            // ✅ FIX: Attach the submit listener ONCE (outside modal open handler)
            const requestQuoteButton = document.querySelector('#request-quote-button');
            if (requestQuoteButton && !requestQuoteButton.dataset.listenerAdded) {
                requestQuoteButton.dataset.listenerAdded = "true";

                requestQuoteButton.addEventListener("click", async (e) => {
                    e.preventDefault();

                    // Remove any existing error messages
                    const existingError = document.querySelector('.quote-error-message');
                    if (existingError) {
                        existingError.remove();
                    }

                    // Get form fields
                    const nameField = document.querySelector('#quote-name');
                    const emailField = document.querySelector('#quote-email');
                    const phoneField = document.querySelector('#quote-phone');
                    const postalField = document.querySelector('#quote-postal');
                    const notesField = document.querySelector('#quote-notes');

                    // Validate required fields
                    const name = nameField?.value.trim() || '';
                    const email = emailField?.value.trim() || '';
                    const phone = phoneField?.value.trim() || '';
                    const postal = postalField?.value.trim() || '';
                    const notes = notesField?.value.trim() || '';

                    // Function to show error message
                    const showError = (message) => {
                        const errorDiv = document.createElement('div');
                        errorDiv.className = 'quote-error-message';
                        errorDiv.textContent = message;
                        
                        const quoteForm = document.querySelector('#quote-form');
                        quoteForm.insertAdjacentElement('beforebegin', errorDiv);
                        
                        // Scroll to error message
                        errorDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    };

                    // Check if all required fields are filled
                    if (!name || !email || !phone || !postal || !notes) {
                        showError('Please fill in all required fields.');
                        return;
                    }

                    // Basic email validation
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(email)) {
                        showError('Please enter a valid email address.');
                        return;
                    }

                    // Show loading spinner
                    const originalButtonText = requestQuoteButton.innerHTML;
                    requestQuoteButton.innerHTML = '<span class="quote-button-loading"></span>';
                    requestQuoteButton.disabled = true;

                    try {
                        const ipapiObject = await fetch('https://ipinfo.io/json?token=9d6c0decb21c0b');
                        const geoLocation = await ipapiObject.json();
                        const currentCurrency = geoLocation?.country === 'CA' ? 'CAD' : 'USD';
                        const currencyToCountryMap = {
                            "USD": "US",
                            "CAD": "CA"
                        };

                        fetch('/apps/proxy-me/submit-quote-request', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                customerEmail: email,
                                customerName: name,
                                customerPhone: phone,
                                customerPostal: postal,
                                customerNotes: notes,
                                currency: currentCurrency,
                                country: currencyToCountryMap[currentCurrency],
                                searchText: window.mwApoInit.product.title,
                            })
                        });

                        setTimeout(() => {
                            requestQuoteButton.innerHTML = '<span class="quote-button-success">✓</span>';
                                
                            // Wait 1.5 seconds, then close modal and reset form
                            setTimeout(() => {
                                MicroModal.close('quote-modal');
                                requestQuoteButton.innerHTML = originalButtonText;
                                requestQuoteButton.disabled = false;
                                
                                // Reset form fields
                                nameField.value = '';
                                emailField.value = '';
                                phoneField.value = '';
                                postalField.value = '';
                                notesField.value = '';
                            }, 1500);
                        }, 1000);
                    } catch (error) {
                        console.error('Error submitting quote:', error);
                        showError('There was an error submitting your quote request. Please try again.');
                        requestQuoteButton.innerHTML = originalButtonText;
                        requestQuoteButton.disabled = false;
                    }
                });
            }
        });
    
        observer.observe(document.body, { childList: true, subtree: true });     

        const microModalObserver = new MutationObserver(() => {
            function disablePageScroll() {
                // Save the current scroll position
                document.body.dataset.scrollY = window.scrollY;
                document.body.style.position = 'fixed';
                document.body.style.top = `-${window.scrollY}px`;
                document.body.style.left = '0';
                document.body.style.right = '0';
                document.body.style.overflow = 'hidden';
                document.body.style.width = '100%';
            }

            function enablePageScroll() {
                const scrollY = document.body.dataset.scrollY;
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.left = '';
                document.body.style.right = '';
                document.body.style.overflow = '';
                document.body.style.width = '';
                window.scrollTo(0, parseInt(scrollY || '0'));
            }

            if (window.MicroModal && typeof MicroModal.show === 'function') {
                microModalObserver.disconnect();
                MicroModal.init({
                    disableScroll: true,
                    closeOnOverlayClick: false,
                    onShow: modal => {
                        console.log(modal)
                        disablePageScroll();
                        
                        const overlay = modal.querySelector('.modal__quote-overlay');
                        const container = modal.querySelector('.modal__quote-container');
                    
                        overlay.addEventListener('click', function (e) {
                            // Get the visual bounding box of the modal container
                            const bounds = container.getBoundingClientRect();
                    
                            // Check if the click was outside the modal box
                            const clickedOutside =
                                e.clientX < bounds.left ||
                                e.clientX > bounds.right ||
                                e.clientY < bounds.top ||
                                e.clientY > bounds.bottom;
                    
                            if (clickedOutside) {
                                MicroModal.close(modal.id);
                            }
                        });
                    },
                    awaitCloseAnimation: false, // optional, turn off if you're not animating
                    onClose: () => {
                        // Optionally return focus to a known element like body or a trigger button
                        document.activeElement.blur(); // this line prevents focus conflict
                        enablePageScroll();
                    }
                });
            }
        });

        // Observe document for script injections or new globals
        microModalObserver.observe(document.documentElement, { childList: true, subtree: true });

        // Failsafe timeout (stop after 10s to prevent infinite observe)
        setTimeout(() => microModalObserver.disconnect(), 10000);
    });
})();